import React, { Fragment } from 'react';
import { SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useCommonContext } from '../../../hooks/useContexts';
export var CancelItemsSkeleton = function (_a) {
    var alertState = _a.alertState;
    var isMobile = useCommonContext().isMobile;
    return (React.createElement(React.Fragment, null,
        isMobile && alertState ? (React.createElement(SkeletonBlock, null)) : (React.createElement(SkeletonLine, { variant: "heading", fullWidth: true })),
        Array.from({ length: 3 }, function (unused, index) { return (React.createElement(Fragment, { key: index },
            React.createElement("div", { className: "sui-flex sui-flex-row sui-my-5 sui-items-start sui-gap-3" },
                React.createElement("div", { id: "massCancelSkeleton" },
                    React.createElement(SkeletonBlock, null)),
                React.createElement("div", { className: "sui-flex-1" },
                    React.createElement(SkeletonLine, { numberOfLines: 2 }))),
            React.createElement("div", { className: "sui-mb-5" }, isMobile && React.createElement(SkeletonLine, { numberOfLines: 2 })))); }),
        isMobile ? (React.createElement("div", { className: "sui-flex sui-w-1 sui-mt-7 " },
            React.createElement(SkeletonLine, { numberOfLines: 2 }))) : (React.createElement("div", { className: "sui-flex sui-justify-end sui-mr-5" },
            React.createElement("div", { className: "sui-w-1/2 sui-mt-3" },
                React.createElement(SkeletonLine, { variant: "heading", fullWidth: true }))))));
};
export var CDLineItemCardSkeleton = function () {
    var isMobile = useCommonContext().isMobile;
    return (React.createElement(React.Fragment, null, Array.from({ length: 3 }, function (unused, index) { return (React.createElement(Fragment, { key: index },
        React.createElement("div", { className: "sui-flex sui-flex-row sui-my-5 sui-items-start sui-gap-3" },
            React.createElement("div", { id: "massCancelSkeleton" },
                React.createElement(SkeletonBlock, null)),
            React.createElement("div", { className: "sui-flex-1" },
                React.createElement(SkeletonLine, { numberOfLines: 2 }))),
        React.createElement("div", { className: "sui-mb-5" }, isMobile && React.createElement(SkeletonLine, { numberOfLines: 2 })))); })));
};
